export default "__VITE_ASSET__B$s4q9lf__"